import type { Dev2222Mode } from './experience'

const STORAGE_KEY = 'sigchatExpmgrDev2222Mode'

function isMode(v: string | null): v is Dev2222Mode {
  return v === 'jwt' || v === 'forceA' || v === 'forceB'
}

export function readDev2222ModeFromSession(): Dev2222Mode {
  if (!import.meta.env.DEV) return 'jwt'
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (raw !== null && isMode(raw)) return raw
  } catch {
    return 'jwt'
  }
  return 'jwt'
}

export function writeDev2222ModeToSession(mode: Dev2222Mode): void {
  if (!import.meta.env.DEV) return
  try {
    sessionStorage.setItem(STORAGE_KEY, mode)
  } catch {
    return
  }
}
